export const ALL_SYSTEM_TYPES = "all-system-types";
export const ALL_SPARE_PART_TYPES = "all-spare-part-types";

export const SPARE_PARTS = "spare-parts";
export const UPGRADES = "upgrades";
export const SERVICE_TOOLS = "service-tools";

export const SUBST_SINGLE = "Z00";
export const SUBST_OR = "Z001";
export const SUBST_AND = "Z002";
